import {Action} from '@ngrx/store';
import {type} from '../../shared/utilities/type';
import {CommonField} from '../../shared/models/common-field';

// TODO: not used

export const programsActionTypes = {
  LOAD: type('[Programs] Load'),
  LOAD_SUCCESS: type('[Programs] Load Success'),
  LOAD_FAIL: type('[Programs] Load Error')
};

export class LoadProgramsAction implements Action {
  readonly type = programsActionTypes.LOAD;
  constructor() {}
}

export class LoadProgramsSuccessAction implements Action {
  readonly type = programsActionTypes.LOAD_SUCCESS;
  constructor(public payload?: CommonField[]) {}
}

export class LoadProgramsFailAction implements Action {
  readonly type = programsActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
